export const certData = [
     {
        title: "AWS Certified Developer Associate",
        certificationUrl: "https://www.credly.com/badges/3b808752-7911-43be-8b1d-5b788894a44b",
        issuedBy: "Amazon Web Services Training and Certification",
        image: {}
    },
    {
        title: "Certified Kubernetes Application Developer",
        certificationUrl: "https://learn.kodekloud.com/user/certificate/54ce1e2f-d1cf-4f5d-936a-2d416b129916",
        issuedBy: "KodeKloud",
        image: {}
    },
    {
        title: "AWS Educate Getting Started with Serverless - Training Badge",
        certificationUrl: "https://www.credly.com/badges/b58474c7-d819-4205-94cc-c75f64b23a04/public_url",
        issuedBy: "Amazon Web Services Training and Certification",
        image: {}
    },
    {
        title: "Istio Service Mesh",
        certificationUrl: "https://learn.kodekloud.com/user/certificate/54ce1e2f-d1cf-4f5d-936a-2d416b129916",
        issuedBy: "KodeKloud",
        image: {}
    },
    {
        title: "Apache Kafka Fundamentals",
        certificationUrl: "https://learn.kodekloud.com/user/certificate/b608af1d-5f08-4b69-b894-7b61a545db70",
        issuedBy: "KodeKloud",
        image: {}
    }
]